import AlertLinkWrapper from './alert-link-wrapper';

export default AlertLinkWrapper;
